import React from "react";
import { Route, Routes } from "react-router-dom";
import ClerkForm from "./components/ClerkForm";
import HomePage from "./components/HomePage";
import AssistanceForm from "./components/AssistanceForm";
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";
import ClerkData from "./admin/ClerkData";
import AssistanceData from "./admin/AssistanceData";
import LastPage from "./components/LastPage";

function App() {
  return (
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/clerk-form" element={<ClerkForm />} />
        <Route path="/assistance-form" element={<AssistanceForm />} />
        <Route path="/last" element={<LastPage />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/dashboard" element={<AdminDashboard />} />
        <Route path="/clerk" element={<ClerkData />} />
        <Route path="/assistant" element={<AssistanceData />} />
      </Routes>
  );
}

export default App;

/*
npm install react-router-dom

import React from 'react'

const Footer = () => {

    const currentYear = new Date().getFullYear();

  return (
   <div className="row m-0 p-0">
    <div className="col-md-12" style={{display:"flex",justifyContent:"center",alignItems:"center",padding:"10px",fontSize:"12px",backgroundColor:"#000",color:"#fff"}}>
        <span>Copyright &copy; {currentYear} | Design & Developed By <a href="https://www.technoaarv.com/" target='_blank' style={{cursor:"pointer",color:"white",textDecoration:"none"}}>TechnoAarv</a></span>        
    </div>
   </div>
  )
}

export default Footer
*/